import { render, staticRenderFns } from "./assign-supervisor.vue?vue&type=template&id=4431cf01&"
import script from "./assign-supervisor.vue?vue&type=script&lang=js&"
export * from "./assign-supervisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports